export const defaultPageOptions = [
  { label: "10/page", value: 10 },
  { label: "25/page", value: 25 },
  { label: "50/page", value: 50 },
  { label: "100/page", value: 100 },
  { label: "250/page", value: 250 },
  { label: "500/page", value: 500 },
];
